import { render, staticRenderFns } from "./c-bottom-Adaptive.vue?vue&type=template&id=72bb05c0&scoped=true&"
import script from "./c-bottom-Adaptive.vue?vue&type=script&lang=js&"
export * from "./c-bottom-Adaptive.vue?vue&type=script&lang=js&"
import style0 from "./c-bottom-Adaptive.vue?vue&type=style&index=0&id=72bb05c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb05c0",
  null
  
)

export default component.exports